"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportDataDialog = void 0;
const MetaModelRegistry_1 = __importDefault(require("@opsbase/lib-data-metamodel/MetaModelRegistry"));
const ImportFileHeadings_1 = __importDefault(require("@opsbase/lib-datatype/ImportFileHeadings"));
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useGenerateLMSSDataImport_1 = __importDefault(require("@opsbase/react-gql-hooks/lmss/useGenerateLMSSDataImport"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Dialog_1 = __importDefault(require("@opsbase/web-dialogs/Dialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const CheckIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CheckIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const useParams_1 = __importDefault(require("@opsbase/web-nav/useParams"));
const useTaskWatcherActions_1 = __importDefault(require("@opsbase/web-taskwatcher/useTaskWatcherActions"));
const TextFieldWithEmail_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithEmails/TextFieldWithEmail"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    fileUpload: {
        display: 'inline-block',
        opacity: 1,
        transition: 'opacity 0.3s',
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.6,
        },
        '& input': {
            display: 'none',
            pointerEvents: 'none',
        },
        '& button': {
            pointerEvents: 'none',
        },
    },
});
function ImportDataDialog() {
    const generateLMSSDataImport = (0, useGenerateLMSSDataImport_1.default)();
    const { type } = (0, useParams_1.default)();
    const self = (0, useSelf_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const [addNew, setAddNew] = (0, react_1.useState)(true);
    const [updateExisting, setUpdateExisting] = (0, react_1.useState)(true);
    const [deleteExisting, setDeleteExisting] = (0, react_1.useState)(false);
    const [autoCreate, setAutoCreate] = (0, react_1.useState)(true);
    const [data, setData] = (0, react_1.useState)();
    const [validity, setValidity] = (0, react_1.useState)({ valid: false, errors: [] });
    const [isStarting, setIsStarting] = (0, react_1.useState)(false);
    const [email, setEmail] = (0, react_1.useState)(self.email);
    const { goBack } = (0, useNav_1.default)();
    const { watchTasks } = (0, useTaskWatcherActions_1.default)();
    const metaModel = MetaModelRegistry_1.default[type];
    const importFile = ImportFileHeadings_1.default[type];
    const exampleLink = window.location.href.split('#')[0] + 'assets/examples/example.' + type + '.csv';
    (0, react_1.useEffect)(() => {
        let valid = false;
        const errors = [];
        if (data) {
            valid = true;
            const headings = data
                .split('\n')[0] // FIRST LINE
                .split('"')
                .join('') // TEXT QUALIFIERS
                .split(','); // SPLIT BY COLUMN
            headings.some(h => {
                if (importFile.indexOf(h.trim().toUpperCase()) < 0) {
                    valid = false;
                    errors.push('"' +
                        h.trim() +
                        '" is not a valid column when importing ' +
                        (0, getFromStringOrFunction_1.getFromStringOrFunction)(metaModel.name));
                }
            });
        }
        setValidity({ valid, errors });
    }, [data, importFile, metaModel.name, type]);
    const handleClickStart = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        setIsStarting(true);
        const task = yield generateLMSSDataImport({
            email,
            type,
            data,
            addNew,
            updateExisting,
            deleteExisting,
            autoCreate,
        });
        setIsStarting(false);
        watchTasks([task]);
        goBack();
    }), [
        addNew,
        autoCreate,
        data,
        deleteExisting,
        email,
        generateLMSSDataImport,
        goBack,
        type,
        updateExisting,
        watchTasks,
    ]);
    const handleChangeFile = (0, react_1.useCallback)(e => {
        const file = e.target.files.length ? e.target.files[0] : undefined;
        if (file) {
            const fileReader = new FileReader();
            fileReader.onload = () => setData(fileReader.result);
            fileReader.readAsText(file);
        }
    }, []);
    if (!metaModel.canImportData)
        return null;
    return (react_1.default.createElement(Dialog_1.default, { size: DialogSize_1.default.X800_Y400, scroll: true, title: lib_i18n_1.default.t('import-data') + ': ' + (0, getFromStringOrFunction_1.getFromStringOrFunction)(metaModel.name), buttonsRight: react_1.default.createElement(Button_1.default, { disabled: !validity.valid, label: isStarting ? '' : lib_i18n_1.default.t('import-data'), loading: isStarting, onClick: handleClickStart }) },
        react_1.default.createElement(Vertical_1.default, { gutter: true },
            react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('import-data-intro-text'))),
            react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(Horizontal_1.default, { gutter: true },
                    react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.GreyBlue, label: lib_i18n_1.default.t('download-sample-csv'), link: exampleLink, target: "_blank" }),
                    react_1.default.createElement("label", { htmlFor: "fileUpload", className: myCss.fileUpload },
                        react_1.default.createElement("input", { id: "fileUpload", type: "file", accept: "text/csv", onChange: handleChangeFile }),
                        react_1.default.createElement(Button_1.default, { color: validity.valid ? lib_palette_1.default.positive : lib_palette_1.default.secondary, label: lib_i18n_1.default.t('upload-csv') })),
                    react_1.default.createElement(Pane_1.default, { grow: true }, !!validity.valid && react_1.default.createElement(CheckIcon_1.default, { color: lib_palette_1.default.positive, size: 30 }))),
                !!validity.errors && !!validity.errors.length && (react_1.default.createElement(Vertical_1.default, { padding: true }, validity.errors.map((err, idx) => (react_1.default.createElement(Text_1.default, { color: "error", key: idx }, err)))))),
            react_1.default.createElement(Vertical_1.default, { shrink: true },
                react_1.default.createElement(Checkbox_1.default, { label: 'Add any new ' +
                        (0, getFromStringOrFunction_1.getFromStringOrFunction)(metaModel.name) +
                        ' found in the CSV', checked: addNew, onChange: setAddNew }),
                react_1.default.createElement(Checkbox_1.default, { label: 'Update any existing ' +
                        (0, getFromStringOrFunction_1.getFromStringOrFunction)(metaModel.name) +
                        ' found in the CSV?', checked: updateExisting, onChange: setUpdateExisting }),
                react_1.default.createElement(Checkbox_1.default, { label: 'Delete any ' +
                        (0, getFromStringOrFunction_1.getFromStringOrFunction)(metaModel.name) +
                        ' not found in the CSV? (use with care)', checked: deleteExisting, onChange: setDeleteExisting }),
                metaModel.importableRelatedData && (react_1.default.createElement(Checkbox_1.default, { label: 'Automatically create related data (' +
                        metaModel.importableRelatedData +
                        ')?', checked: autoCreate, onChange: setAutoCreate }))),
            react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('import-email-when-complete')),
                react_1.default.createElement(TextFieldWithEmail_1.default, { value: email, onChange: setEmail, fullWidth: true })))));
}
exports.ImportDataDialog = ImportDataDialog;
exports.default = ImportDataDialog;
